import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { makeStyles } from "tss-react/mui";
import { Icon } from "../../../icons/Icon.js";
import { CustomIcon } from "../../../icons/types.js";
import "../../../icons/ExpandMoreIcon.js";
import "@mui/material";
import { StyledTooltip } from "../../../tooltip/Tooltip.js";
import "moment-timezone";
import { isNullOrUndefined } from "../../../../utils/object.js";
import "react-intl";
import "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import "../../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import { SystemColorsEnum } from "../../../../style/types.js";
import "../../../../style/hooks.js";
const useClasses = makeStyles()((theme) => ({
  invalidDataCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.palette.error.main
  }
}));
function isInvalidDataValue(value) {
  return typeof value === "object" && !isNullOrUndefined(value) && "__invalidData" in value && value.__invalidData === true;
}
function InvalidDataCell({ raw }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement("span", { className: classes.invalidDataCell }, /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.ErrorCircleOutline, color: SystemColorsEnum.Red }), "Invalid Data"),
      title: /* @__PURE__ */ React.createElement("span", null, raw)
    }
  );
}
function renderCellWithErrorBoundary(renderCell) {
  return (params) => {
    const rawModel = params.row?.__rawModel;
    return isInvalidDataValue(params.value) || rawModel?.isValid === false ? /* @__PURE__ */ React.createElement(InvalidDataCell, { raw: rawModel.raw }) : /* @__PURE__ */ React.createElement(ErrorBoundary, { fallback: /* @__PURE__ */ React.createElement(InvalidDataCell, { raw: rawModel?.raw }) }, renderCell(params));
  };
}
function valueGetterWithErrorHandling(valueGetter) {
  return (...args) => {
    try {
      return valueGetter.apply(null, args);
    } catch {
      return { __invalidData: true };
    }
  };
}
export {
  isInvalidDataValue,
  renderCellWithErrorBoundary,
  valueGetterWithErrorHandling
};
//# sourceMappingURL=InvalidDataCell.js.map
